import React, { useState, useLayoutEffect } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { provinces, local_market, province_market_map } from '../../constants';
import MainBankUsagePPTX from '../../powerpoint/MainBankUsagePPTX';

am4core.useTheme(am4themes_animated);

const ChannelInteractionChart = () => {
  const [selectedProvince, setSelectedProvince] = useState('');
  const [selectedLocalMarket, setSelectedLocalMarket] = useState('');
  const [localMarkets, setLocalMarkets] = useState([]);
  
  // Static chart data for 3D bar chart
  const chartData = [
    { category: 'ATM (CASH)', percentage: 91 },
    { category: 'CELLPHONE BANKING', percentage: 33 },
    { category: 'CONSULTANT (BRANCH)', percentage: 28 },
    { category: 'INTERNET BANKING', percentage: 47 },
    { category: 'MOBILE BANKING APP', percentage: 47 },
    { category: 'RETAIL STORE', percentage: 50 },
    { category: 'TELLER', percentage: 28 },
    { category: 'OTHER', percentage: 17 }
  ];

  // Handlers for province and local market filters
  const handleProvinceChange = (e) => {
    const selectedProvince = e.target.value;
    setSelectedProvince(selectedProvince);
    
    if (selectedProvince && province_market_map[selectedProvince]) {
      setLocalMarkets(province_market_map[selectedProvince].local_markets);
    } else {
      setLocalMarkets([]);
    }
    setSelectedLocalMarket('');
  };

  const getProvinceValue = () => {
    return selectedProvince ? provinces[selectedProvince] : ''; 
  };

  const getLocalMarketValue = () => {
    return selectedLocalMarket ? local_market[selectedLocalMarket] : ''; 
  };

  useLayoutEffect(() => {
    let chart = am4core.create('bargraph3ddiv', am4charts.XYChart3D);
    chart.logo.disabled = true;

    chart.data = chartData; // Static data for the chart

    let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'category';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 20;
    categoryAxis.renderer.grid.template.disabled = true;
    categoryAxis.renderer.labels.template.rotation = -50;
    categoryAxis.renderer.labels.template.verticalCenter = 'middle';
    categoryAxis.renderer.labels.template.horizontalCenter = 'right';
    categoryAxis.renderer.labels.template.dy = 0;
    categoryAxis.renderer.labels.template.fontWeight = '450';

    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.min = 0;
    valueAxis.max = 100;
    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.labels.template.disabled = true;

    let series = chart.series.push(new am4charts.ColumnSeries3D());
    series.dataFields.valueY = 'percentage';
    series.dataFields.categoryX = 'category';
    series.name = 'Percentage';
    series.columns.template.tooltipText = '{categoryX}: [bold]{valueY}%[/]';
    series.columns.template.fillOpacity = 0.8;
    series.columns.template.width = am4core.percent(65);

    let labelBullet = series.bullets.push(new am4charts.LabelBullet());
    labelBullet.label.text = '{valueY}%';
    labelBullet.label.hideOversized = true;
    labelBullet.label.truncate = false;
    labelBullet.label.horizontalCenter = 'middle';
    labelBullet.label.verticalCenter = 'middle';
    labelBullet.label.dx = 10; 
    labelBullet.label.fontSize = 18;
    labelBullet.label.fill = am4core.color('black');
    labelBullet.label.fontWeight = '500';

    series.columns.template.adapter.add('fill', function(fill, target) {
      return chart.colors.getIndex(target.dataItem.index);
    });
    
    return () => {
      chart.dispose();
    };
  }, []);

  return (
    <div className='home'>
      <div className='filter'>
        <label htmlFor="province-select">Province: </label>
        <select
          id="province-select"
          value={selectedProvince}
          onChange={handleProvinceChange}
        >
          <option value="">All</option>
          {Object.keys(provinces).map((province) => (
            <option key={province} value={province}>
              {province}
            </option>
          ))}
        </select>
        
        <label htmlFor="local-market-select">Local Market: </label>
        <select
          id="local-market-select"
          value={selectedLocalMarket}
          onChange={(e) => setSelectedLocalMarket(e.target.value)}
          disabled={!selectedProvince || localMarkets.length === 0}
        >
          <option value="">All</option>
          {localMarkets.map((market, index) => (
            <option key={index} value={market}>
              {market}
            </option>
          ))}
        </select>
      </div>

       <div>
        <MainBankUsagePPTX
          selectedProvince={selectedProvince}
          selectedLocalMarket={selectedLocalMarket}
          maindata={chartData}
        />
      </div> 

      <div 
        id="bargraph3ddiv" 
        style={{ 
          width: '80%', 
          height: '500px', 
          margin: '0 auto', 
          boxShadow: '6px 6px 16px rgba(173, 216, 230, 0.5)',
          marginTop: '30px'
        }}
      ></div>
    </div>
  );
};

export default ChannelInteractionChart;
